import React from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "@/lib/useFetch";
import { usePageMeta, breadcrumbLd, siteUrl } from "@/lib/usePageMeta";
import { useI18n } from "@/contexts/I18nContext";
import { NotFoundState, ErrorState } from "@/components/StateViews";
import { AuthorAvatar } from "@/components/AuthorAvatar";
import { EntityPage, EntitySkeleton } from "@/components/EntityPage";
import { JsonLd } from "@/components/JsonLd";

export default function AuthorDetail() {
  const { slug } = useParams();
  const { lang, t } = useI18n();
  const { status, data: a, reload } = useFetch(`/authors/${encodeURIComponent(slug)}`);
  const name = a ? (lang === "hi" ? a.name_hi : (a.name_en || a.name_hi)) : "";
  usePageMeta({ title: a ? name : status === "notfound" ? t("not_found_title") : undefined,
    description: a?.bio, type: "profile", image: a?.photo || undefined, noindex: status === "notfound" || status === "error" });

  if (status === "notfound") return <NotFoundState />;
  if (status === "error") return <ErrorState onRetry={reload} />;
  if (!a) return <EntitySkeleton />;

  const other = lang === "hi" ? a.name_en : (a.name_en ? a.name_hi : "");
  return (
    <>
      <JsonLd data={{ "@context": "https://schema.org", "@type": "Person", name: a.name_hi,
        ...(a.name_en ? { alternateName: a.name_en } : {}), ...(a.photo ? { image: a.photo } : {}),
        url: `${siteUrl()}/authors/${a.slug}` }} />
      <JsonLd data={breadcrumbLd([{ name: t("site_name"), path: "/" }, { name: t("all_authors"), path: "/authors" }, { name: a.name_hi, path: `/authors/${a.slug}` }])} />
      <EntityPage
        mark={<AuthorAvatar src={a.photo} name={a.name_hi} className="w-24 shrink-0 sm:w-32" />}
        title={name} subtitle={other !== name ? other : ""} titleTestId="author-name"
        rating={a.avg_rating} reviewCount={a.review_count}
        text={a.bio} textTestId="author-bio" adPlacement="person-after-bio"
        books={a.books} booksTitle={t("nav_books")}
        targetType="author" target={a}
      />
    </>
  );
}
